import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { convertImage } from 'appSrc/utils';
import style from './styles/style.module.css';

import defaultProfileIcon from 'appSrc/assets/img/profile/avatar.svg';

export default class UserAvatar extends PureComponent {
    render() {
        var inlineStyle = {
            ...this.props.style,
            boxShadow: this.props.shadow ? '0 12px 36px 0 rgba(0, 0, 0, 0.07)' : 'none',
            overflow: 'visible',
            borderRadius: '50%',
            lineHeight: '.5',
        };
        var src = this.props.src || defaultProfileIcon;

        if( this.props.size ) {
            inlineStyle.width = inlineStyle.height = this.props.size + 'px';
            src = convertImage( src, `/${ this.props.size }x${ this.props.size }` );
        }

        const className = ( this.props.className + ' ' + style.userAvatar ).trim();
        const avatarClassName = ( this.props.avatarClassName + ' ' + style.imageWrapper ).trim();

        return (
            <div style={ inlineStyle } className={ className }>
                <div className={ avatarClassName }>
                    <img src={ src } />
                </div>
            </div>
        );
    }
}
UserAvatar.defaultProps = {
    shadow: true,
    className: '',
    avatarClassName: '',
};
UserAvatar.propTypes = {
    src: PropTypes.string,
    size: PropTypes.number,
    shadow: PropTypes.bool,
};
